export default __webpack_public_path__ + "static/media/conceptos-clave-2.0bd3e982.png";